import { head, last } from 'lodash/fp';
import { DateTime, Duration } from 'luxon';

import { LuxonFormats } from 'lib/constants/luxonFormats';
import { Iso8601DateString } from 'lib/types';

export const getTimeElapsed = (timestamps: string[], format: LuxonFormats): string => {
  const duration = Duration.fromObject({
    milliseconds:
      timestamps.length > 1
        ? DateTime.fromISO(last(timestamps) as Iso8601DateString).diff(
            DateTime.fromISO(head(timestamps) as Iso8601DateString),
          ).milliseconds
        : 0,
  });
  return duration.toFormat(format);
};
